// extracted by mini-css-extract-plugin
export var modalFooter = "_ox-0";